
import React,{useState,useEffect} from 'react';
import { toast } from 'react-toastify';
import Loading from '~/components/loading/loading';
import { apiRaw } from "~/services/api";
import { DivContainer, DivContentResult } from './styleConfirmaAgendamento';
export default  function ConfirmaAgendamento({location}) {
    const params =  new URLSearchParams( location.search );
    const paramsAgendamento = { e:params.get( 'e' ),c:params.get('c')}
    const [display, setDisplay] = useState("none");

    async function confirmaConsulta(){
        try {
            const responseConfirmaConsulta = await apiRaw.post(`whatsapp/confirmaConsultaPaciente`,paramsAgendamento);
            if(responseConfirmaConsulta.status == 200){
                return responseConfirmaConsulta.data
            }else{
                toast.error('Erro ao tentar confirmar agendamento.')
            }
        } catch (error) {
            toast.error('Não foi possível confirmar agendamento.')
        }
    }

   async function init(){
        setDisplay('flex')
        const resultConfirmaAgendamento = await confirmaConsulta()        
        setDisplay('none')
    }

    useEffect(()=>{
        init()
    },[])
    return <DivContainer>
         {
            paramsAgendamento?.c == "true"?
                <DivContentResult>
                    <div>🤩</div>
                    <h5>Consulta confirmada, obrigado pela resposta.</h5>
                </DivContentResult>
            :
                <DivContentResult>
                    <div>😔</div>
                    <h5>Sentimos muito pela impossibilidade de comparecer à consulta, mas compreendemos imprevistos. <br/>Por favor, entre em contato para remarcar. Estamos aqui para auxiliar.</h5>
                </DivContentResult>
         }        
        <Loading mostrar={display} />
    </DivContainer>;
}